import { useEffect, useState } from "react"

/**
 * Hook to manage stadium lights flash and CTA press effects.
 * IMPORTANT: This logic must match the original EXACTLY.
 */
export function useStadiumLightsEffects() {
  // Flash logic: temporarily boost lights to full brightness when a sport
  // emoji is clicked (signalled by a global "sportsEmojiClick" event).
  const [flashActive, setFlashActive] = useState(false)

  // Track if the Landing CTA is currently being pressed
  const [ctaPressActive, setCtaPressActive] = useState(false)

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null

    const handleFlash = () => {
      // Restart the flash timer on each click so rapid clicks feel responsive
      setFlashActive(true)
      if (timeoutId) clearTimeout(timeoutId)
      timeoutId = setTimeout(() => setFlashActive(false), 1000)
    }

    window.addEventListener("sportsEmojiClick", handleFlash)
    return () => {
      window.removeEventListener("sportsEmojiClick", handleFlash)
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [])

  useEffect(() => {
    const handlePressStart = () => setCtaPressActive(true)
    const handlePressEnd = () => setCtaPressActive(false)

    window.addEventListener("landingCTApressStart", handlePressStart)
    window.addEventListener("landingCTApressEnd", handlePressEnd)

    return () => {
      window.removeEventListener("landingCTApressStart", handlePressStart)
      window.removeEventListener("landingCTApressEnd", handlePressEnd)
    }
  }, [])

  return { flashActive, ctaPressActive }
}
